import React from 'react';
import FieldYesNo from './fields/fieldYesNo';
import DataDevis from '../dataDevis';
import FieldDate from './fields/fieldDate';

export default class LegalDetails extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const container = this.props.container
        const devis = container.devis
        const params = devis.params
        const need_A2 = devis.need_A2()
        const permis_B = params.categorie_permis == 'B'
        const permis_A2 = params.categorie_permis == 'A2'
        return <>
            {need_A2
                ? <FieldYesNo field="permis_A_obtenu_par_formation" container={container}  />
                : ''}
            {need_A2
                ? <><FieldYesNo field="aussi_permis_A2" container={container} />
                { ( params.aussi_permis_A2 == 'O' )?<>
                    <FieldDate field="date_obtention_permis_A2" container={container} />
                </>:''}</>
                : ''}
            {( permis_A2 || permis_B )
                ? <FieldYesNo field="bridee_47_5CV" container={container}  />
                : ''}
            {permis_B
                ? <FieldYesNo field="formation_F125" container={container}  />
                : ''}
            <FieldYesNo field="antecedant_400cm3_24mois" container={container}  />
        </>

    }
}